<script lang="ts">
  /**
   * One JSON-LD block, serialised from an object.
   *
   * The existing schema on the keyword pages is hand-written JSON inside a
   * `{@html}` template literal — which is how `firmenadressen-kaufen` ended up
   * with a `FAQPage` whose questions had drifted from the ones it renders, and
   * means a trailing comma ships as an unparseable block that no build step
   * would notice.
   *
   * Angle brackets are replaced with their unicode escape, which JSON-LD
   * parsers accept, so no string value can close the script element early.
   * The data is authored in this repository, but that is a property of
   * today's callers rather than a guarantee of this component.
   */
  let { data }: { data: unknown } = $props();

  const json = $derived(JSON.stringify(data, null, 2).replace(/</g, '\\u003c'));
</script>

<svelte:head>
  <!-- eslint-disable-next-line svelte/no-at-html-tags -->
  {@html `<script type="application/ld+json">${json}</` + `script>`}
</svelte:head>
